import { createBrowserHistory } from 'history'

const history = createBrowserHistory({ forceRefresh: true })

export { history }
